import { render, staticRenderFns } from "./deleteNotepad.vue?vue&type=template&id=68b6abae&scoped=true"
import script from "./deleteNotepad.vue?vue&type=script&lang=js"
export * from "./deleteNotepad.vue?vue&type=script&lang=js"
import style0 from "./deleteNotepad.vue?vue&type=style&index=0&id=68b6abae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6abae",
  null
  
)

export default component.exports